import { fadeInOut } from '../../services/animations';
import { takeWhile } from 'rxjs/operators';
import { Component, AfterViewInit, ViewContainerRef, ViewChildren, ComponentFactory, Type, NgModule, QueryList, ViewEncapsulation, ElementRef, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import $ from "jquery";
import { ActivatedRoute, Router } from '@angular/router';
import { ProgrammesService } from '../../services/programmes.service';
import { Programme } from '../../models/programme.model';
import { ProgrammesModalComponent } from '../programmes/modal/programmes.modal.component';


@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.scss'],
  animations: [fadeInOut],
})


export class ProgrammesComponent implements AfterViewInit, OnInit {

  @ViewChildren('programmeRow', { read: ViewContainerRef }) children: QueryList<ViewContainerRef>;
  programmes: Array<Programme>;
  sortKey = 'nom';
  sortReverse = false;
  searchTerm: string;
  public loading: boolean = false;
  bsModalRef: BsModalRef;
  initialisation: boolean;
  routeToRead: boolean = true;
  private sub: any;
  myEventSubscription: any;

  constructor(
    private service: ProgrammesService,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private elementRef: ElementRef
  ) { }

  
  ngOnInit(): void {
    this.loading = true;
    this.initialisation = true;
    this.service.getProgrammes().subscribe(res => {
      this.programmes = res;
      this.loading = false;

      this.sub = this.route.params.pipe(
        takeWhile(() => this.routeToRead))
        .subscribe(params => {
          //var CompetenceId = params['competenceId']; utile??
          var ProgrammeId = params['programmeId'];
          if (ProgrammeId) {
            setTimeout(() => {
              const el: any = this.children.find(x => x.element.nativeElement.id === 'collapseProgramme' + ProgrammeId);
              const element: any = ($(el.element.nativeElement) as any);
              const programme = this.programmes.find(x => x.programmeId == ProgrammeId);

              element.collapse('show');
              this.loadCompetences(programme);

              $('html, body').animate({
                scrollTop: element.position().top - 44
              }, 1000);
            }, 100);
          }
          this.routeToRead = false;
        });

    });
  }

  ngAfterViewInit(): void {
    function toggleChevron(e: any) {
    $(e.target)
      .prev('.panel-heading')
      .find("i.indicator")
      .toggleClass('expanded');
    }
    $('#accordion').on('hidden.bs.collapse', toggleChevron);
    $('#accordion').on('shown.bs.collapse', toggleChevron);

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = () => { scrollFunction() };

    function scrollFunction() {
      var backToTop = $('.back-to-top');
      if (backToTop != null) {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          $('.back-to-top').fadeIn(200);
        } else {
          $('.back-to-top').fadeOut();
        }
      }
    }
  }
 
  changeSortKey(newSortKey: string): void {
    if(this.sortKey == newSortKey) {
      this.sortReverse = !this.sortReverse;
      }
      else {
        this.sortKey = newSortKey;
        this.sortReverse = false;
    }
  }

  private loadCompetences(programme: any): void {
    this.initialisation = false;
    var isExpand = $('a[href^="#collapseProgramme' + programme.programmeId + '"]').find('.fa-chevron-right').hasClass('expanded');
    if (!isExpand) {
      this.service.getCompetencesWithProgrammeId(programme.programmeId).subscribe(x => {
        programme.competences = x;
      });
    }
  }

  openDetailsModal(programme?: any) {
    let initialState = {};
    if (programme) {
      initialState = {
        programme: Object.assign({}, programme)
      };
    } else {
      initialState = {
        programme: null
      };
    }

    this.bsModalRef = this.modalService.show(ProgrammesModalComponent, {
      initialState: initialState,
      class: 'gray modal-lg',
      ignoreBackdropClick: true
    });
    this.myEventSubscription =
      this.modalService.onHide.subscribe(() => {
        this.service.getProgrammes().subscribe(x => {
          this.programmes = x;
          this.initialisation = true;
          this.myEventSubscription.unsubscribe();
        });
      });
  }

  // When the user clicks on the button, scroll to the top of the document
    backToTop() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    }

  clearSearchTerm() {
    this.searchTerm = '';
    this.service.getProgrammes().subscribe(x => {
      this.programmes = x;
      this.initialisation = true;
    });
  }

  collapseListeProgrammes() {
    this.service.getProgrammes().subscribe(x => {
      this.programmes = x;
      this.initialisation = true;
    });
  }


}
